const INTEGRATED_HELP_STORAGE_KEY = 'drift-integrated-help-triggered'

export const saveHelpInteractionStart = () => {
  if (window.localStorage && window.localStorage.setItem) {
    window.localStorage.setItem(INTEGRATED_HELP_STORAGE_KEY, new Date().getTime() + "")
  }
}

export const getLastHelpInteractionEpoch = () => {
  const savedTime = window.localStorage && window.localStorage.getItem && window.localStorage.getItem(INTEGRATED_HELP_STORAGE_KEY)
  const parsedEpoch = parseInt(savedTime)
  return !isNaN(parsedEpoch) ? parsedEpoch : null
}

export const shouldLaunchHelpInteraction = () => {
  const lastHelpInteraction = getLastHelpInteractionEpoch()
  const oneDayAgo = new Date()
  oneDayAgo.setDate(oneDayAgo.getDate() - 1)

  // If there is no last interaction or its been more than a day since the last
  return !lastHelpInteraction || lastHelpInteraction < oneDayAgo.getTime()
}

export const startInteraction = (interactionId: number) => {
  if (window.drift.api) {
    window.drift.api.startInteraction({ interactionId })
  } else {
    window.drift.on('ready', (api) => {
      api.startInteraction({ interactionId })
    })
  }
}

export const openChat = () => {
  if (window.drift.api) {
    window.drift.api.openChat()
  } else {
    window.drift.on('ready', (api) => {
      api.openChat()
    })
  }
}



// WEBPACK FOOTER //
// ./client/app/drift-nav/integrated-help-utils.ts